const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};


function restructureAutocomplete() {
  const container = document.querySelector('.wizzy-autocomplete-suggestions');
  if (!container) return;

  if (container.querySelector('.autocomplete-section')) return;

  const mainList = container.querySelector('.autocomplete-suggestions-list');
  if (!mainList) return;

  const items = Array.from(mainList.children);

  const newContent = document.createElement('div');
  newContent.className = 'autocomplete-suggestions-list';

  let currentItemsList = null;

  items.forEach(item => {
    if (item.classList.contains('autocomplete-item-head')) {
      const section = document.createElement('div');
      section.className = 'autocomplete-section';

      section.appendChild(item);

      const scrollContainer = document.createElement('div');
      scrollContainer.className = 'autocomplete-scroll-container';

      currentItemsList = document.createElement('ul');
      currentItemsList.className = 'autocomplete-suggestions-list';

      scrollContainer.appendChild(currentItemsList);
      section.appendChild(scrollContainer);
      newContent.appendChild(section);

    } else if (item.classList.contains('autocomplete-item') && currentItemsList) {
      currentItemsList.appendChild(item);
    }
  });

  mainList.replaceWith(newContent);
}


function reorderSuggestionsOnly(suggestions) {
    const recent = [];
    const trending = [];
    const others = [];

    suggestions.forEach(item => {
        if (item.group === "recentSearches") recent.push(item);
        else if (item.group === "trendingSearches") trending.push(item);
        else others.push(item);
    });

    // 🔥 IMPORTANT:
    // DO NOT TOUCH item.index

    return [...recent, ...trending, ...others];
}


console.log("wizzy loaded");

window.onWizzyScriptLoaded = function () {
  // changeTemplate("wizzy-search-results-product");
  // changeTemplate("wizzy-autocomplete-topproducts");
  // changeTemplate("wizzy-search-empty-results");
  // changeTemplate("wizzy-search-wrapper");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      console.log(data," <-- BEFORE_INIT");
      // window.wizzyConfig.common.isLazyInit = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = !0;
      wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      data.autocomplete.configs.defaultBehaviour.topProducts.enabled = true;
      data.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.data.categories =[
          "sale"
      ]
      data.autocomplete.configs.defaultBehaviour.suggestions.displayRecent = true;
      data.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.data.productsCount = 9;
      data.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.expiry = "session";
      data.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.method = "filters";
      data.autocomplete.configs.defaultBehaviour.topProducts.displayRecent = "false";
      data.autocomplete.configs.defaultBehaviour.topProducts.displayTrending = "false";
      data.autocomplete.topProducts.title = "Most-Loved Signature Pieces";
      data.autocomplete.searchBar.hasAnimatedPlaceholders = true;
      data.autocomplete.searchBar.animatedPlaceholders = [
                "Search For winter collection",
                "Search For kurta sets",
                "Search For anarkali set",
                "Search For winter kurtas",
                "Search For kurta set",
                "Search For saree",
                "Search For kurtas",
                "Search For dupatta",
                "Search For velvet",
                "Search For velvet winter collection"

      ]
      data.gridFilters.enabled = true;
        data.gridFilters.filters =[
        {
            "key": "categories",
            "question": "Select categories",
            "after": {
                "web": 6,
                "mobile": 4
            }
        },
        {
            "key": "colors",
            "question": "Select colors",
            "after": {
                "web": 12,
                "mobile": 8
            }
        },
        {
            "key": "product_Size",
            "question": "Select size",
            "after": {
                "web": 18,
                "mobile": 12
            }
        },
        {
            "key": "product_neck_type_custom",
            "question": "Choose product_neck_type_custom",
            "after": {
                "web": 27,
                "mobile": 16
            }
        }
    ]
      

      return data;
    }
  ,3);

      window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
        if(window.innerWidth < 768){
         setTimeout(restructureAutocomplete, 50);
        }
         return data;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      // console.log(data," <-- BEFORE_INIT");
      // window.wizzyConfig.common.isLazyInit = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = !0;
      wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      data.autocomplete.configs.defaultBehaviour.topProducts.enabled = true;
      data.autocomplete.configs.defaultBehaviour.suggestions.displayRecent = true;

      data.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.data.categories =[
          "sale"
      ]
      data.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.data.productsCount = 10;
      data.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.expiry = "session";
      data.autocomplete.configs.defaultBehaviour.topProducts.defaultPool.method = "filters";
      data.autocomplete.configs.defaultBehaviour.topProducts.displayRecent = "false";
      data.autocomplete.configs.defaultBehaviour.topProducts.displayTrending = "false";
      data.autocomplete.topProducts.title = "Most-Loved Signature Pieces";
      data.autocomplete.searchBar.hasAnimatedPlaceholders = true;
      data.autocomplete.searchBar.animatedPlaceholders = [
                "Search For winter collection",
                "Search For kurta sets",
                "Search For anarkali set",
                "Search For winter kurtas",
                "Search For kurta set",
                "Search For saree",
                "Search For kurtas",
                "Search For dupatta",
                "Search For velvet",
                "Search For velvet winter collection"

      ]
      return data;
    }
  ,1);
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
    data.filters.attributeFacetValuesLimit = 100;
    
    if (data.group === "defaultMenu") {
        const categoryHandle = data?.filters?.categories?.[0];
        categoryHandle && (data.filters.sort = [{
            field: `product_${categoryHandle}_sortOrder:float`,
            order: "asc"
        }])
    }


    return data;
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.attributeFacetValuesLimit = 100;

      // console.log(data," <-- BEFORE_SEARCH_EXECUTED");
      let closeButton = document.querySelector(
        ".wizzy-search-back"
      );
      if (closeButton) closeButton.click();

      const body = document.querySelector("body");
      if (body) {
        body.classList.remove("predictive-search--focus");
        console.log("Removed predictive-search--focus class from <body>");
      } else {
        console.log("Body element or predictive-search--focus class not found");
      }
      const header = document.querySelector(
        '.header-wrapper.header-wrapper--border-bottom.header-wrapper--uppercase.header-transparent'
      );

      if (header) {
        header.classList.remove('header-transparent');
      }
      const buttons = document.querySelectorAll('.search__button[aria-label="Close"]');

      buttons.forEach(btn => btn.click());
      data.includeOutOfStock = "true";

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // console.log(window.data,"AFTER_PRODUCTS_TRANSFORMED");
      // window.deep = data;
      data.forEach((product) => {
        product.new = false;
        product.plusSize = false;
        // product.recycled = false;
        // product.twoToThirteen = false;
        // product.sevenToThirteen = false;
        // product.soldOutTag = false;
        product.similarProducts = false;
        product.handle = "";
        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_tags") {
            //    if (attribute.values.some(value => value.value.includes('Badge1: NEW LAUNCH'))) {
            //   product.plusTag = true;
            // }
            attribute.values.forEach((tag) => {
              if (tag.value.some((value) => value.includes("new-product"))) {
                product.new = true;
              }
            });
            attribute.values.forEach((tag) => {
              if (tag.value.some((value) => value.includes("plus-side"))) {
                product.plusSize = true;
              }
            });
            // attribute.values.forEach(tag => {
            //     if (tag.value.some(value => value.includes('USP1:RECYCLED'))) {
            //         product.recycled = true;
            //     }
            // });
            // attribute.values.forEach(tag => {
            //     if (tag.value.some(value => value.includes('USP1:2-13 Years'))) {
            //         product.twoToThirteen = true;
            //     }
            // });
            //  attribute.values.forEach(tag => {
            //     if (tag.value.some(value => value.includes('USP1:7-13 Years'))) {
            //         product.sevenToThirteen = true;
            //     }
            // });

            // if (attribute.values.some(value => value.value.includes('Best-Seller'))) {
            //   product.preLaunchTag = true;
            // }
          }
          if (attribute.id === "product_similar_product_custom") {
            console.log("wizzy getting true");
            if (attribute.values.length > 0) {
              product.similarProducts = true;
            }
          }
          if (attribute.id === "product_handle") {
            product.handle = attribute.values[0].value[0];
          }
        });
      });

      data.forEach((product) => {
        product.discountAvailable = false;
        product.totalVariants = false;
        if (product.swatches) {
          if (product.swatches[0]) {
            if (product.swatches[0].values.length > 1) {
              product.totalVariants = true;
            } else {
              product.totalVariants = false;
            }
          }
        }
        if (product.discount) {
          const newValue = parseInt(product.discount);
          if (newValue > 0) {
            product.discountAvailable = true;
          }
        }
      });

      data.forEach((product) => {
        // Check if the last three characters of price are '.00' and remove them if necessary
        if (product.price) {
          if (product.price.endsWith(".00")) {
            product.price = product.price.slice(0, -3); // Remove the last three characters
          }
        }
        if (product.sellingPrice) {
          if (product.sellingPrice.endsWith(".00")) {
            product.sellingPrice = product.sellingPrice.slice(0, -3); // Remove the last three characters
          }
        }
        if (product.discount) {
          if (product.discount.endsWith(".00")) {
            product.discount = product.discount.slice(0, -3); // Remove the last three characters
          }
          var discountPrice = product.discount;
          if (discountPrice) {
            product.discount = discountPrice.replace(/,/g, "");
          }
        }
      });

      if (data.length == 1) {
        document.body.classList.add("wizzy-single-product");
      } else {
        document.body.classList.remove("wizzy-single-product");
      }

      data.forEach((product) => {
        product?.swatches?.forEach((swatch) => {
          if (swatch.key == "sizes") {
            swatch.values = swatch?.values?.sort((a, b) => {
              const swatchValuesOrder = {
                XS: 0,
                S: 1,
                M: 2,
                L: 3,
                XL: 4,
                "2XL": 5,
                XXL: 6,
                "3XL": 7,
                "4XL": 8,
                FS: 9,
                WS: 10,
              };
              return (
                swatchValuesOrder[a.swatchValue] -
                swatchValuesOrder[b.swatchValue]
              );
            });
          }
        });
      });

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {


      console.log(data, "<====VIEW_RENDERED");

      // Select all the "ADD TO CART" buttons
      const addToCartButtons = document.querySelectorAll(".mobile__cart__icon");
      addToCartButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          event.stopPropagation();

          const productItem = event.target.closest(".wizzy-result-product");
          const productId = productItem.getAttribute("data-id");
          const cartCard = productItem.querySelector(".main__cart_card");

          if (cartCard) {
            if (
              cartCard.style.display === "none" ||
              cartCard.style.display === ""
            ) {
              cartCard.style.display = "block";
            } else {
              cartCard.style.display = "none";
            }
          }
        });
      });

      document.querySelectorAll(".wizzy-search-wrapper .cstm__size_coll a").forEach((link) => {
        link.addEventListener("click", function (event) {
          event.preventDefault();
          const variationId = this.getAttribute("data-attr");
          const cardBottom = this.closest(".cstm__card_bottom");
          if (!cardBottom) return;
          cardBottom.querySelectorAll(".cstm__size_coll a").forEach((a) => a.classList.remove("active_size"));
          this.classList.add("active_size");
          const addToCartButton = cardBottom.querySelector(".cstm__card_button");
          if (addToCartButton) {
            addToCartButton.setAttribute("data-id", variationId);
            if (document.documentElement.clientWidth < 768) {
              addToCartButton.click();
            }
          }
        });
      });

    document.querySelectorAll('.product-media-wrapper').forEach((wrapper) => {
      const slideshow = wrapper.querySelector('.product-image-slideshow');
      const images = (slideshow && slideshow.querySelectorAll('img')) || [];
      const dots = wrapper.querySelectorAll('.product-dots .dot');

      // Agar 1 ya usse kam images → kuch mat karo
      if (!images.length || images.length === 1) {
        if (images.length === 1) images[0].style.opacity = '1';
        return;
      }

      let currentIndex = 0;
      let touchStartX = 0;
      let touchStartY = 0;
      let autoInterval = null;

      function showSlide(idx) {
        currentIndex = (idx + images.length) % images.length; // always 0..length-1

        images.forEach((img, i) => {
          img.style.opacity = i === currentIndex ? '1' : '0';
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === currentIndex);
        });
      }

      function next() {
        showSlide(currentIndex + 1);
      }

      function prev() {
        showSlide(currentIndex - 1);
      }

      // ── Desktop hover autoplay ────────────────────────────────
      wrapper.addEventListener('mouseenter', () => {
        if (autoInterval) clearInterval(autoInterval);
        autoInterval = setInterval(next, 2200); // slow & comfortable
      });

      wrapper.addEventListener('mouseleave', () => {
        if (autoInterval) {
          clearInterval(autoInterval);
          autoInterval = null;
        }
        showSlide(0); // reset to first
      });

      // ── Mobile swipe (ignore vertical scroll) ─────────────────
      wrapper.addEventListener(
        'touchstart',
        (e) => {
          const t = e.touches[0];
          touchStartX = t.clientX;
          touchStartY = t.clientY;
        },
        { passive: true }
      );

      wrapper.addEventListener(
        'touchend',
        (e) => {
          const t = e.changedTouches[0];
          const diffX = touchStartX - t.clientX;
          const diffY = touchStartY - t.clientY;

          // mostly horizontal swipe and big enough
          if (Math.abs(diffX) > 20 && Math.abs(diffX) > Math.abs(diffY)) {
            if (diffX > 0) next(); // left swipe → next
            else prev(); // right swipe → prev
          }
        },
        { passive: true }
      );

      // ── Dots click ────────────────────────────────────────────
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          showSlide(idx);
          // Manual click pe autoplay pause (better UX)
          if (autoInterval) {
            clearInterval(autoInterval);
            autoInterval = null;
          }
        });
      });

      // Initial state set kar do
      showSlide(0);
    });

    const email = __wzrk_customer_email;
    const id =  __wzrk_customer_identity;
    const phone = __wzrk_customer_phone;


  document
    .querySelectorAll(".wizzy-result-product .swym-add-to-wishlist-view-product .before_wish")
    .forEach(svg => {
      if (email) svg.setAttribute("customer-email", email);
      if (id) svg.setAttribute("customer-id", id);
      if (phone) svg.setAttribute("customer-phone", phone);
    });
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {
    console.log("BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER",data);
    if(data.isForDefault === true){
      var newSuggestionsOrder = reorderSuggestionsOnly(data.suggestions);
      data.suggestions = newSuggestionsOrder;
    }
    console.log("data",data);
    return data;
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      // console.log(data, "<====PRODUCTS_CACHED_RESULTS_RENDERED");

      // Select all the "ADD TO CART" buttons
      const addToCartButtons = document.querySelectorAll(".mobile__cart__icon");
      addToCartButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          event.stopPropagation();

          const productItem = event.target.closest(".wizzy-result-product");
          const productId = productItem.getAttribute("data-id");
          const cartCard = productItem.querySelector(".main__cart_card");

          if (cartCard) {
            if (
              cartCard.style.display === "none" ||
              cartCard.style.display === ""
            ) {
              cartCard.style.display = "block";
            } else {
              cartCard.style.display = "none";
            }
          }
        });
      });

      document.querySelectorAll(".wizzy-search-wrapper .cstm__size_coll a").forEach((link) => {
        link.addEventListener("click", function (event) {
          event.preventDefault();
          const variationId = this.getAttribute("data-attr");
          const cardBottom = this.closest(".cstm__card_bottom");
          if (!cardBottom) return;
          cardBottom.querySelectorAll(".cstm__size_coll a").forEach((a) => a.classList.remove("active_size"));
          this.classList.add("active_size");
          const addToCartButton = cardBottom.querySelector(".cstm__card_button");
          if (addToCartButton) {
            addToCartButton.setAttribute("data-id", variationId);
            if (document.documentElement.clientWidth < 768) {
              addToCartButton.click();
            }
          }
        });
      });

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      console.log(data, " <-- BEFORE_RENDER_RESULTS");
      const body = document.querySelector("body");
      if (body) {
        body.classList.remove("predictive-search--focus");
        console.log("Removed predictive-search--focus class from <body>");
      } else {
        console.log("Body element or predictive-search--focus class not found");
      }
      var facets = data?.response?.payload?.facets;

      if (facets) {
        facets.forEach((facet) => {
          if (facet.key === "colors") {
            // var facetsData = facet.data;
            // facetsData.forEach((facetData) =>{
            //   facetData.isURLSwatch = false;
            //   if (facetData.data.swatch) {
            //     facetData.data.swatch.value = facetData.data.value;
            //   }
            //   // if (facetData.data.swatch.value.includes("Red")){
            //   //   facetData.data.swatch.value = "Red";
            //   // }
            //   console.log("Wiz->>", facetData.data.swatch.value);
            // });
          }
        });
      }

      const sizeOrder = [
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "2XL",
        "XXL",
        "3XL",
        "4XL",
        "FS",
        "WS",
      ];
      function compareSizes(a, b) {
        if (!isNaN(a.label) && !isNaN(b.label)) {
          return Number(a.label) - Number(b.label);
        }

        if (sizeOrder.includes(a.label) && sizeOrder.includes(b.label)) {
          return sizeOrder.indexOf(a.label) - sizeOrder.indexOf(b.label);
        }

        if (!isNaN(a.label)) {
          return 1;
        } else {
          return -1;
        }
      }

      if (data.response.payload.facets) {
        const sizesFacet = data.response.payload.facets.find(
          (facet) => facet.key === "product_Size"
        );
        if (sizesFacet) {
          sizesFacet.data.sort(compareSizes);
        }
      }

      return data;
    }
  );

      if (window.innerWidth <= 768) {
    const front_input = document.querySelector(".search__input.field__input");

    front_input && front_input.addEventListener("click", function (e) {
      e.preventDefault();
      const back_input = document.querySelector("#search_mini_form input");
      back_input && back_input.click();
      let search_form = document.querySelector("#search_mini_form");
      search_form && (search_form.style.display = "block",
        setTimeout(() => {
          let search_bar = search_form.querySelector("input");
          search_bar && search_bar.click()
        }
          , 300));
    });
  }
};

////////////////////////////////////////////////////////////////////////////////////

const searchIcon = document.querySelector(".header__icon.header__icon--search");

if (searchIcon) {
  searchIcon.addEventListener("click", function () {
    const searchInput = document.querySelector(".search__input");

    setTimeout(function () {
      searchInput.click();
    }, 300);
  });
}

////////////////////////////////////////////////////////////////////////////////////////

function checkScroll() {
  const scrollPercentage =
    ((document.documentElement.scrollTop + document.body.scrollTop) /
      (document.documentElement.scrollHeight -
        document.documentElement.clientHeight)) *
    100;

  const body = document.body;

  if (scrollPercentage >= 1) {
    body.classList.add("wizzy-scrolled");
  } else {
    body.classList.remove("wizzy-scrolled");
  }
}

window.addEventListener("scroll", checkScroll);
